import {
  trigger,
  transition,
  style,
  animate,
  state,
} from '@angular/animations';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, AbstractControl } from '@angular/forms';
import * as moment_ from 'moment';

const moment = moment_;

@Component({
  selector: 'lib-form-control',
  templateUrl: './form-control.component.html',
  styleUrls: ['./form-control.component.scss'],
  animations: [
    trigger('transitionMessages', [
      state('enter', style({ opacity: 1, transform: 'translateY(0%)' })),
      transition('void => enter', [
        style({ opacity: 0, transform: 'translateY(-100%)' }),
        animate('300ms cubic-bezier(0.55, 0, 0.55, 0.2)'),
      ]),
    ]),
  ],
})
export class FormControlComponent implements OnInit {
  @Input() variant:
    | 'text'
    | 'check'
    | 'multiline'
    | 'select'
    | 'multiselect'
    | 'timepicker'
    | 'datepicker' = 'text';
  @Input() class: string | object;
  @Input() label: string;
  @Input() placeholder: string = '';
  @Input() formGroupParent: FormGroup;
  @Input() controlName: string;
  @Input() msgValidations: any[] = [];
  @Input() rows: number;
  @Input() options: any[] = [];
  @Input() bindLabel: string = 'label';
  @Input() bindValue: string = 'value';
  @Input() bindObject: boolean = false;
  @Input() fullWidth: boolean = true;
  @Input() disabled: boolean = false;
  @Input() maxItems: number = 5;
  @Input() maxDate: any = null;
  @Input() minDate: any = moment('1900-01-01');
  @Input() readonly: boolean = false;
  @Input() appendToBody: boolean = false;
  @Input() appendTo: string = null;
  @Input() maxSelectedLabels: number = 4;
  @Input() inputProps: any = { type: 'text' };
  @Input() showCharCount: boolean = false;
  @Input() defaultTimeParam: string = '12:00 AM';
  @Input() appearance: 'legacy' | 'standard' | 'fill' | 'outline' = 'legacy';
  @Input() value: any = null;
  @Input() clearable: boolean = true;
  //@Output('on-change') onChangeEvent: EventEmitter<any> = new EventEmitter();

  @Input() isRequired: boolean = false;
  errorToLoad: boolean = false;
  isSearchingOnSelect: boolean = false;
  isRequiredFalse: boolean;

  VARIANT_TYPE = {
    text: 'text',
    text2: 'text2',
    multiline: 'multiline',
    select: 'select',
    multiselect: 'multiselect',
    datepicker: 'datepicker',
    check: 'check',
    timepicker: 'timepicker'
  };

  constructor() { }

  ngOnInit() {
    try {
      this.formGroupParent.get(this.controlName);
      this.checkIsRequired();
    } catch (e) {
      this.errorToLoad = true;
      console.error(
        `No existe el controlName "${this.controlName}" en el FormGroup`,
      );
    }
  }
  /*
    get showError(): boolean {
      return this.formGroupParent.get(this.controlName).invalid &&
        (this.formGroupParent.get(this.controlName).dirty || this.formGroupParent.get(this.controlName).touched);
    }*/

  handleChange = e => { };

  checkIsRequired = () => {
    // const control = this.formGroupParent.get(this.controlName);
    // if (control.validator) {
    //   const validator = control.validator({} as AbstractControl);
    //   if (validator && (validator.required || validator.whitespace)) {
    //     this.isRequired = true;
    //   }
    // }

    this.isRequiredFalse = this.isRequired !== false;

  };

  HandleClearValue = () => {
    this.formGroupParent.get(this.controlName).setValue(null);
  };

  handleSearch = e => {
    if (e.term) {
      this.isSearchingOnSelect = true;
    } else {
      this.isSearchingOnSelect = false;
    }
  };

  handleBlur = e => {
    this.isSearchingOnSelect = false;
  };

  get hasError() {
    return (
      this.formGroupParent.get(this.controlName).invalid &&
      (this.formGroupParent.get(this.controlName).dirty ||
        this.formGroupParent.get(this.controlName).touched)
    );
  }

  get isEmpty(): boolean {
    const value = this.formGroupParent.get(this.controlName).value;
    if (Array.isArray(value) && value.length == 0) {
      return true;
    }

    if (value) {
      return false;
    }
    return true;
  }
}
